import { RulAiVariable } from 'rulAi'

export const addOrUpdateElement = (arr: RulAiVariable[], newElem: RulAiVariable): RulAiVariable[] => {
  return [...arr.filter((obj) => obj.name !== newElem.name), { ...newElem }]
}
